import mobileMenu from "GesagtGetan.Basic/Resources/Private/Assets/Scripts/mobileMenu";
import requestAnimationFrame from "GesagtGetan.Basic/Resources/Private/Assets/Scripts/requestAnimationFrame";

let scrolled = false;

function easeInOutCirc(t, b, c, d) {
    if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
}

function scrollAnimateToTop(navigation, bottom) {
    let change = bottom * -1;
    let currentTime = 0;
    let increment = 20;
    let duration = 800;

    function animateScroll() {
        // increment the time
        currentTime += increment;
        navigation.scrollTop = easeInOutCirc(
            currentTime,
            bottom,
            change,
            duration
        );
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
        }
    }
    animateScroll();
}

_gg.domJsReady(() => {
    mobileMenu();
    _gg.Gator(document).on("mobileMenu.close", function(event) {
        let header = event.detail.header;
        setTimeout(() => {
            header.classList.remove("headroom--unpinned");
            header.classList.add("headroom--pinned");
        }, 10);
    });
    _gg.Gator(document).on("mobileMenu.open", function(event) {
        if (!scrolled) {
            scrolled = true;
            let navigation = event.detail.navigation;
            // Only if we have 100px we wabt to scroll
            let height = navigation.firstElementChild.offsetHeight - 100;
            // 55px is the header height + 15px padding = 85px
            let visibleHeight = window.innerHeight - 85;
            let bottom = height - visibleHeight;

            if (visibleHeight < height) {
                // Start at the bottom
                navigation.scrollTo(0, bottom);
                setTimeout(() => {
                    scrollAnimateToTop(navigation, bottom);
                }, 500);
            }
        }
    });
});
